<template>
  <div class="elevation-5 signing">
    <div class="logo-wrapper">
      <div class="logo"></div>
    </div>
    <div class="sign-box">
      <div class="input-box">
        <p class="title">
          <i class="fas fa-envelope fa-fw"></i>
          ENTER YOUR EMAIL
        </p>
        <div class="form-input">
          <v-text-field
            v-model="email"
            placeholder="Email Address"
            :rules="emailRules"
            full-width
            @keyup.enter="sendEmail"
          ></v-text-field>
        </div>
        <v-btn
          class="btn-login send-email"
          large block
          @click.native="sendEmail"
        >Send password reset eamil</v-btn>
      </div>
      <div class="help-box">
        <router-link :to="{ name: 'signIn' }">
          <button class="no-underline">
            <i class="fas fa-undo-alt fa-fw"></i>
            Back to login
          </button>
        </router-link>
      </div>
    </div>
    <p class="copyright">COPYRIGHT ⓒImGATE ALL RIGHTS RESERVED.</p>
  </div>
</template>

<script>
  import api from '../../api';

  export default {
    data() {
      return {
        email: null,
        emailRules: [
          v => (v === 0) || !!v || 'Please input Email',
          /* eslint max-len: ["error", { "code": 200 }] */
          v => /^\w+([\\.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
      };
    },
    methods: {
      sendEmail() {
        const params = {
          email: this.email,
        };
        api.sendEmail(params)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success send email';
            this.alertOccur();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/signing/PwdReset.vue